import { t } from 'react-switch-lang';
import mailcheck from 'mailcheck';

export function validateMaxCharacter(value, characterLimit) {
  if (value.trim().length > characterLimit) return t('Validation_Length_Max').replace('xMax', characterLimit);
  return null;
}

export function validateEmpty(value) {
  if (value.trim().length === 0) return t('Validation_Required');
  return null;
}

export function validateEmail(value) {
  if (validateEmpty(value)) return validateEmpty(value);
  if (validateMaxCharacter(value, 50)) return validateMaxCharacter(value, 50);
  if (!/^[\w!#$%&*+/=?`{|}~^-]+(?:\.[\w!#$%&*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,32}$/.test(value)) return t('Validation_Type_Email');
  return null;
}

export function validateTransactionNumber(value) {
  if (!/^(?:\d{13})?$/.test(value.trim())) return t('Contact_Paysimply_InvalidTransactionNumber');
  return null;
}

export function validateCardNumber(value) {
  if (validateEmpty(value)) return validateEmpty(value);
  if (!/^[0-9]+$/.test(value)) return t('Validation_Type_Number');
  if (value.length !== 12) return t('Validation_Length_Exact').replace('xLength', '12');
  return null;
}

export function validateSINNumber(value) {
  const sinRegex = /\b(\d{3}-\d{3}-\d{3}|\d{3}\s\d{3}\s\d{3}|\d{9})\b/gm;
  if (sinRegex.test(value)) {
    return t('Contact_General_SINNotAllowed');
  }
  return null;
}

export function validatePANNumber(value) {
  const panRegex = /\b(\d{4}-\d{4}-\d{4}-\d{4}|\d{4}\s\d{4}\s\d{4}\s\d{4}|\d{16})\b/gm;
  if (panRegex.test(value)) {
    return t('Contact_General_CardNumberNotAllowed');
  }
  return null;
}

export function validateName(value) {
  return validateEmpty(value) || validateMaxCharacter(value, 50);
}

export function validateBody(value) {
  return validateEmpty(value) ||
  validateMaxCharacter(value, 1500) ||
  validateSINNumber(value) ||
  validatePANNumber(value);
}

export const mailcheckValidate = (value) => mailcheck.run({
  email: value,
  suggested(suggestion) {
    return suggestion.full;
  },
  empty() {
    return null;
  },
});
